



























































import { computed, defineComponent } from "@vue/composition-api";

const tabs = [
	{ name: "overview", icon: "mdi.information" },
	{ name: "blueprint", icon: "mdi.state-machine" },
	{ name: "live", icon: "mdi.progress-clock" },
	{ name: "sessions", icon: "mdi.chart-timeline-variant" },
	{ name: "tasks", icon: "mdi.hexagon-multiple-outline" },
	{ name: "settings", icon: "mdi.cogs" },
];

export default defineComponent({
	setup(props, ctx) {


		const studyId = computed(() => {
			const r = ctx.root.$route;
			return r.params["studyId"] || r.params["groupId"];
		});


		const getTabLabel = (tab: any) => {
			return tab.label;
		};

		const displayTabs = computed(() => {
			return tabs.map((t) => {
				const label =
					t.name.charAt(0).toUpperCase() + t.name.slice(1);
				return {
					...t,
					label,
					route: `Run.Group.${label}`,
				};
			});
		});

		const isActive = (tab: any) => {
			const res = (ctx.root.$route as any).name.match(
				`${tab.route}*`,
			);
			return Boolean(res);
		};

		const openTab = (tab: any) => {
			if (ctx.root.$route.name === tab.route) {
				return;
			}
			if (studyId) {
				ctx.root.$router.push({
					name: tab.route,
					params: {
						groupId: studyId.value,
					},
				}).catch(() => {})
			}
		};

		return {
			displayTabs,
			studyId,
			getTabLabel,
			isActive,
			openTab,
		};
	},
});
